import { defineNuxtPlugin } from "#app"
import mitt from "mitt"

export default defineNuxtPlugin(() => {
  // Create the emitter per app instance. On the server every request gets its
  // own Nuxt app, so a module-level emitter would be shared by all requests and
  // every `$bus.$on` made during SSR would be retained for the process lifetime.
  const emitter = mitt()

  return {
    provide: {
      bus: {
        $on: emitter.on,
        $off: emitter.off,
        $emit: emitter.emit,
      },
    },
  }
})
